import theme from 'shared/assets/style/theme';
import defaultTheme from './defaultTheme';
import { ASSET_KEY, assetSource } from 'shared/utils/assetSource';
import { isAndroid, isMobile, isTablet, isIOS, isFirefox } from 'react-device-detect';
import { isNotStandaloneMobilePWA, isStandalonePWA, pwaStyleAdapter } from '../utils/mobileSupported';

const windowWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const HriTheme = {
  ...defaultTheme,
  AssetPreloader: {
    ...defaultTheme.AssetPreloader,
    wideLoadingBarcontainer: {
      ...defaultTheme.AssetPreloader.wideLoadingBarcontainer,
      top: isFirefox && isMobile ? (isNotStandaloneMobilePWA ? '49%' : '35%') : isNotStandaloneMobilePWA ? isAndroid ? '51%' : (viewportHeight < 340 ? '56%' : '50%') : '36%',
      transform: isNotStandaloneMobilePWA ? 'translateY(-50%)' : 'none',
    },
  },
  LimitedTimeOffer: {
    ...defaultTheme.LimitedTimeOffer,
    BannerContainer: {
      ...defaultTheme.LimitedTimeOffer.BannerContainer,
      marginBottom: '.75%',
    },
  },
  DailySpin: {
    ...defaultTheme.DailySpin,
    MileStoneRowLoyaltyIcon: {
      ...defaultTheme.DailySpin.MileStoneRowLoyaltyIcon,
      marginBottom: '1rem',
    },
    MilestoneLoyaltyValue: {
      marginBottom: isAndroid ? 6 : 0,
    },
    MilestoneCoinsValue: {
      ...defaultTheme.DailySpin.MilestoneCoinsValue,
      marginBottom: 6,
    },
    mileStoneRowCoinIcon: {
      ...defaultTheme.DailySpin.mileStoneRowCoinIcon,
      top: 0,
    },
    RegDaysItemLoyaltyIcon: {
      ...defaultTheme.DailySpin.RegDaysItemLoyaltyIcon,
      marginTop: -12,
    },
  },
  CurrencyDisplay: {
    ...defaultTheme.CurrencyDisplay,
    LoyaltyLabel: {
      ...defaultTheme.CurrencyDisplay.LoyaltyLabel,
      paddingLeft: windowWidth < 1300 ? 30 : 20,
    },
  },
  NavigationBar: {
    ...defaultTheme.NavigationBar,
    LoyaltyBarContainer: {
      ...defaultTheme.NavigationBar.LoyaltyBarContainer,
      marginLeft: '-0.05rem',
    },
    BarSection: {
      ...defaultTheme.NavigationBar.BarSection,
      paddingBottom: 10,
    },
    LoyaltyCurrencyWrapperStyle: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyWrapperStyle,
      position: 'absolute',
      right:
        isMobile && !isTablet ? 'calc(50% - 235px)' : windowWidth < 1300 ? 'calc(50% - 200px)' : 'calc(50% - 205px)',
    },
    LoyaltyCurrencyIconStyleWithMissionsbar: {
      ...defaultTheme.NavigationBar.LoyaltyCurrencyIconStyleWithMissionsbar,
      ...(isAndroid && isMobile && { left: 10 }),
    },
  },
  ForgotPassword: {
    ...defaultTheme.ForgotPassword,
    ModalContainer: {
      ...defaultTheme.ForgotPassword.ModalContainer,
      height: isMobile ? '55vh' : '70vh',
      minHeight: '300px',
    },
  },
  Tier: {
    ...defaultTheme.Tier,
    Card: {
      ...defaultTheme.Tier.Card,
      width: 75,
    },
    TierWrapperMissionInProgress: {
      ...defaultTheme.Tier.TierWrapperMissionInProgress,
      marginRight:
        isAndroid && !isTablet
          ? '5.5vw !important'
          : isTablet && windowWidth > 1150
            ? '70px !important'
            : '100px !important',
    },
  },
  TimeRemaining: {
    ...defaultTheme.TimeRemaining,
    TimerLabel: {
      ...defaultTheme.TimeRemaining.TimerLabel,
      top: '-0.5rem',
    },
    VIPTimer: {
      ...defaultTheme.TimeRemaining.VIPTimer,
      top: pwaStyleAdapter(4.3, 'rem'),
    },
  },
  BonusLinkMessage: {
    ...defaultTheme.BonusLinkMessage,
    PromoImage: {
      ...defaultTheme.BonusLinkMessage.PromoImage,
      paddingTop: '376px',
    },
    BonusLinkButton: {
      ...defaultTheme.BonusLinkMessage.BonusLinkButton,
      textShadow: `1px 1px 0px ${theme.palette.secondary[0]}, 1px -1px 0px ${theme.palette.secondary[0]}, -1px 1px 0px ${theme.palette.secondary[0]}, -1px -1px 0px ${theme.palette.secondary[0]}`,
    },
    BonusButtonContainer: {
      ...defaultTheme.BonusLinkMessage.BonusButtonContainer,
      marginTop: 5,
    },
    CoinsBonusText: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusText,
      marginTop: -3,
    },
    LoyaltyIcon: {
      ...defaultTheme.BonusLinkMessage.LoyaltyIcon,
      marginRight: '10px',
      marginTop: '-8px',
    },
    CoinsBonusContainer: {
      ...defaultTheme.BonusLinkMessage.CoinsBonusContainer,
      paddingTop: isMobile && !isTablet ? (isAndroid ? '378px' : '398px') : '392px',
    },
    LPBonusContainer: {
      ...defaultTheme.BonusLinkMessage.LPBonusContainer,
      paddingTop: isMobile && !isTablet ? '375px' : '376px',
    },
  },
  OfferDetail: {
    ...defaultTheme.OfferDetail,
    PurchaseResponseHighlightHeader: {
      ...defaultTheme.OfferDetail.PurchaseResponseHighlightHeader,
      fontWeight: '600',
    },
    PurchaseResponseHeader: {
      ...defaultTheme.OfferDetail.PurchaseResponseHeader,
      fontWeight: '600',
    },
    RewardCenterPurchaseResponseMessage: {
      ...defaultTheme.OfferDetail.RewardCenterPurchaseResponseMessage,
      fontSize: '1.5em',
    },
    ExclamationIcon: {
      ...defaultTheme.OfferDetail.ExclamationIcon,
      width: 126,
      height: 'auto',
    },
  },
  LinkAccountForm: {
    ...defaultTheme.LinkAccountForm,
    ScreenBackground: {
      backgroundImage: `url(${assetSource(ASSET_KEY.LIGHT_DIVIDER)})`,
      backgroundSize: '80%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 31,
    },
    HeaderTitle: {
      ...defaultTheme.LinkAccountForm.HeaderTitle,
      margin: 4,
      fontSize: isNotStandaloneMobilePWA && isAndroid ? '1.4rem' : '1.8rem',
    },
  },
  OutOfCoin: {
    ...defaultTheme.OutOfCoin,
    QuickBuyOfferDetails: {
      ...defaultTheme.OutOfCoin.QuickBuyOfferDetails,
      bottom: '17%',
    },
  },
  VIPItem: {
    ...defaultTheme.VIPItem,
    VipPackageContainer: {
      ...defaultTheme.VIPItem.VipPackageContainer,
      background: `
      linear-gradient(145deg, #38032e, #452046) padding-box,
      linear-gradient(145deg, #6d3801, #90454d, #c66e5d) border-box
    `,
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
    },
    Divider: {
      ...defaultTheme.VIPItem.Divider,
      background: 'linear-gradient(to right, transparent, rgba(0, 0, 0, 0.7), transparent)',
    },
    LogoImage: {
      ...defaultTheme.VIPItem.LogoImage,
      width: windowWidth > 1500 ? 250 : 200,
    },
  },
  Settings: {
    ...defaultTheme.Settings,
    BackgroundLightDivider: {
      ...defaultTheme.Settings.BackgroundLightDivider,
      backgroundImage: `url(${assetSource(ASSET_KEY.LIGHT_DIVIDER)})`,
      backgroundSize: '80%',
      backgroundRepeat: 'no-repeat',
      backgroundPositionX: 'center',
      backgroundPositionY: 31,
    },
  },
  Wheel: {
    ...defaultTheme.Wheel,
    Amount: {
      ...defaultTheme.Wheel.Amount,
      color: theme.palette.common[1],
      textShadow: '-1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000',
    },
  },
  BottomBar: {
    ...defaultTheme.BottomBar,
    Divider: {
      ...defaultTheme.BottomBar.Divider,
      bottom: -10,
    },
    BarChestItem: {
      ...defaultTheme.BottomBar.BarChestItem,
      marginLeft: !isMobile || isTablet || isAndroid ? 0 : '3rem',
      marginRight: '3.5rem',
    },
    TimerWrapper: {
      ...defaultTheme.BottomBar.TimerWrapper,
      width: isAndroid || !isMobile ? '90%' : isTablet ? '100%' : '110%',
      height: '68%',
      left: !isMobile ? '3rem' : isAndroid ? (isTablet ? '2vw' : '4vw') : isTablet ? '2vw' : 10,
    },
    VIPIcon: {
      ...defaultTheme.BottomBar.VIPIcon,
      height: !isMobile ? '5em' : isAndroid ? (isTablet ? '10vh' : '14vh') : isMobile && !isTablet ? '12vh' : '5.5em',
      position: 'relative',
      left: !isMobile ? 10 : isAndroid ? 'unset' : -5,
    },
    SlotsIcon: {
      ...defaultTheme.BottomBar.SlotsIcon,
      height: isMobile && !isTablet ? '4.5em' : '5em',
      position: 'relative',
      left: !isMobile ? 10 : isTablet ? 'unset' : -5,
      bottom: !isMobile || isAndroid || isTablet ? 'unset' : '-1.8vh',
    },
    ChestOpenBarIcon: {
      ...defaultTheme.BottomBar.ChestOpenBarIcon,
      height: !isMobile ? '5.8em' : isAndroid ? (isTablet ? '10vh' : '13vh') : isTablet ? '11vh' : '5em',
      marginBottom: isStandalonePWA && isTablet ? '0.8rem' : 0,
      marginLeft: !isMobile ? '4em' : isAndroid ? (isTablet ? '4vw' : '7vw') : '3em',
    },
    ChestClosedBarIcon: {
      ...defaultTheme.BottomBar.ChestClosedBarIcon,
      height: !isMobile ? '5.8em' : isAndroid ? (isTablet ? '10vh' : '13vh') : isTablet ? '11vh' : '5em',
      marginBottom: isStandalonePWA && isTablet ? '0.8rem' : 0,
      marginLeft: !isMobile ? '4em' : isAndroid ? (isTablet ? '4vw' : '7vw') : '3em',
    },
    TimerLabel: {
      ...defaultTheme.BottomBar.TimerLabel,
      position: 'relative',
      bottom: 0,
      paddingLeft: isTablet ? (isAndroid ? '18%' : '15%') : isMobile ? '20%' : '19%',
      marginBottom: !isMobile
        ? window.innerHeight > 900
          ? '-5vh'
          : '-5.5vh'
        : isAndroid
          ? isTablet
            ? '-4vh'
            : '-6.2vh'
          : isTablet
            ? '-4.5vh'
            : '-7.3vh',
    },
    TimerBackground: {
      ...defaultTheme.BottomBar.TimerBackground,
      bottom: !isMobile ? '-1.5vh' : isAndroid ? (isTablet ? '-1vh' : '-2vh') : isTablet ? '-1.4vh' : '-2.5vh',
    },
    NotificationMission: {
      ...defaultTheme.BottomBar.NotificationMission,
      left: '0.7rem',
    },
  },
  StoreDownload: {
    ...defaultTheme.StoreDownload,
    Container: {
      ...defaultTheme.StoreDownload.Container,
      backgroundColor: 'black',
    },
  },
  RewardCenter: {
    ...defaultTheme.RewardCenter,
    RewardCenterMainContentHolder: {
      ...defaultTheme.RewardCenter.RewardCenterMainContentHolder,
      paddingLeft: '5px',
      paddingRight: '5px',
    },
    PurchaseSuccess: {
      ...defaultTheme.RewardCenter.PurchaseSuccess,
      Button: {
        ...defaultTheme.RewardCenter.PurchaseSuccess.Button,
        paddingTop: isNotStandaloneMobilePWA
          ? '2.5rem'
          : isStandalonePWA
            ? isTablet && isAndroid
              ? '3rem'
              : '0.5rem'
            : 0,
      },
    },
  },
  CreditCardDetails: {
    ...defaultTheme.CreditCardDetails,
    CheckBoxBackgroundImage: {
      ...defaultTheme.CreditCardDetails.CheckBoxBackgroundImage,
      width: '40%',
    },
  },
  Start: {
    ...defaultTheme.Start,
    Logo: {
      ...defaultTheme.Start.Logo,
      marginTop: window.innerHeight > 700 ? '6%' : '0px',
    },
    MainContentContainer: {
      ...defaultTheme.Start.MainContentContainer,
      marginTop: window.innerHeight > 700 ? 30 : -20,
    },
    MiddleLayoutButtonContainer: {
      ...defaultTheme.Start.MiddleLayoutButtonContainer,
      marginRight: '2rem',
    },
    BottomBarFooterText: {
      ...defaultTheme.Start.BottomBarFooterText,
      marginTop: 10,
      textShadow: '2px 2px 2px #000000',
    },
    MiddleSectionWrapper: {
      ...defaultTheme.Start.MiddleSectionWrapper,
      paddingInlineStart: '0rem',
    },
  },
  ShopScreen: {
    ...defaultTheme.ShopScreen,
    ShopContainer: {
      ...defaultTheme.ShopScreen.ShopContainer,
      PackagesContainer: {
        ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer,
        padding: '6% 5.5rem 0.4rem',
        CoinItem: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.CoinItem,
          left: '2px',
        },
        VIPItemContainer: {
          ...defaultTheme.ShopScreen.ShopContainer.PackagesContainer.VIPItemContainer,
          ...(!isMobile && { marginLeft: 0 }),
        },
      },
    },
  },
  MissionsProgress: {
    ...defaultTheme.MissionsProgress,
    MissionIcon: {
      ...defaultTheme.MissionsProgress.MissionIcon,
      right: isAndroid && !isTablet ? 'calc(50% + 30px)' : isTablet ? 'calc(50% + 33px)' : windowWidth < 1400 ? 'calc(50% + 40px)' : 'calc(50% + 35px)',
      top: -10,
    },
    MissionIconWithoutCard: {
      ...defaultTheme.MissionsProgress.MissionIconWithoutCard,
      right: isAndroid && !isTablet ? 'calc(50% + 30px)' : 'calc(50% + 40px)',
    },
    RankContainer: {
      ...defaultTheme.MissionsProgress.RankContainer,
      right: isAndroid && !isTablet ? 'calc(50% + 30px)' : windowWidth < 1400 ? 'calc(50% + 40px)' : 'calc(50% + 35px)',
      top: -10,
    },
    RankContainerWithNoCard: {
      ...defaultTheme.MissionsProgress.RankContainerWithNoCard,
      right: isAndroid && !isTablet ? 'calc(50% + 35px)' : windowWidth < 1400 ? 'calc(50% + 46px)' : 'calc(50% + 41px)',
      top: -10,
    },
    BarShineEffect: {
      ...defaultTheme.MissionsProgress.BarShineEffect,
      boxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
      WebkitBoxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
      MozBoxShadow: '0px 0px 8px 4px rgba(0, 200, 255, 0.65) inset',
    },
    TimeText: {
      ...defaultTheme.MissionsProgress.TimeText,
      fontSize: 19,
    },
    BarLabel: {
      ...defaultTheme.MissionsProgress.BarLabel,
      ...(isMobile && !isAndroid && { left: '0.5vw' }),
    },
  },
  BattleProgressTooltip: {
    ...defaultTheme.BattleProgressTooltip,
    Title: {
      ...defaultTheme.BattleProgressTooltip.Title,
      textShadow: '1px 1px 1px #632b78',
    },
    LeaderboardHeader: {
      ...defaultTheme.BattleProgressTooltip.LeaderboardHeader,
      textShadow: '1px 1px 1px #632b78',
    },
  },
  BattlesGoal: {
    ...defaultTheme.BattlesGoal,
    InfoText: {
      ...defaultTheme.BattlesGoal.InfoText,
      textShadow: '0px 2px 0px #6a007d',
    },
    Amount: {
      ...defaultTheme.BattlesGoal.Amount,
      textShadow: '0px 3px 0px #6a007d',
    },
  },
  BattlesRankingTable: {
    ...defaultTheme.BattlesRankingTable,
    TableHeaderItem: {
      ...defaultTheme.BattlesRankingTable.TableHeaderItem,
      textShadow: '0px 3px 0px #6a007d',
    },
  },
  BattlesReward: {
    ...defaultTheme.BattlesReward,
    InfoText: {
      ...defaultTheme.BattlesReward.InfoText,
      textShadow: '0px 3px 0px #6a007d',
    },
    InfoAmountContainer: {
      ...defaultTheme.BattlesReward.InfoAmountContainer,
      textShadow: '0px 3px 0px #6a007d',
    },
    Amount: {
      ...defaultTheme.BattlesReward.Amount,
      textShadow: '0px 3px 0px #6a007d',
    },
  },
  BattlesTabsScreen: {
    ...defaultTheme.BattlesTabsScreen,
    InfoText: {
      ...defaultTheme.BattlesTabsScreen.InfoText,
      textShadow: '0px 3px 0px #6a007d',
    },
  },
  MissionCard: {
    ...defaultTheme.MissionCard,
    TimerTextWithIcon: {
      ...defaultTheme.MissionCard.TimerTextWithIcon,
      bottom: '0.2rem',
    },
  },
  LobbyOverlay: {
    ...defaultTheme.LobbyOverlay,
    PinnedPanelContainer: {
      ...defaultTheme.LobbyOverlay.PinnedPanelContainer,
      ...(isMobile && !isTablet && { marginLeft: '12vw !important' }),
    },
  },
  SideBar: {
    ...defaultTheme.SideBar,
    MenuContainer: {
      ...defaultTheme.SideBar.MenuContainer,
      ...(isStandalonePWA && { width: '30vw !important' }),
      marginTop: isTablet && !isAndroid ? '-1rem' : 0,
    },
    Toggler: {
      ...defaultTheme.SideBar.Toggler,
      isMenuVisible: {
        ...defaultTheme.SideBar.Toggler.isMenuVisible,
        right: isMobile ? (isAndroid ? '-1vw' : '3vw') : '-2.5vw',
      },
      isNotVisible: {
        ...defaultTheme.SideBar.Toggler.isNotVisible,
        right: isTablet
          ? isAndroid
            ? '-2vw'
            : '-1vw'
          : isStandalonePWA && isIOS
            ? '-1.5vw'
            : isMobile
              ? '-2.5vw'
              : '-1.4vw',
      },
    },
  },
  Bar: {
    ...defaultTheme.Bar,
    BarContainer: {
      ...defaultTheme.Bar.BarContainer,
      background: 'linear-gradient(180deg, rgba(33, 30, 28, 1) 0%, rgba(158, 136, 49, 1) 100%)',
      WebkitBoxShadow: 'inset -3px 3px 3px rgba(0, 0, 0, 0.6), inset -3px -3px 3px rgba(0, 0, 0, 0.6)',
      MozBoxShadow: 'inset -3px 3px 3px rgba(0, 0, 0, 0.6), inset -3px -3px 3px rgba(0, 0, 0, 0.6)',
    },
  },
  BrowserScreen: {
    ...defaultTheme.BrowserScreen,
    DescriptionWrap: {
      ...defaultTheme.BrowserScreen.DescriptionWrap,
      marginTop: 0,
    },
    ButtonContainer: {
      ...defaultTheme.BrowserScreen.ButtonContainer,
      marginTop: '5vh',
    },
  },
  SignUp: {
    ...defaultTheme.SignUp,
    CheckBox: {
      ...defaultTheme.SignUp.CheckBox,
      height: isMobile ? 30 : 20,
    },
  },
};

export default HriTheme;
